export default __webpack_public_path__ + "static/media/image-off.d8e30144.svg";